const StarIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='10'
            height='10'
            viewBox='0 0 10 10'
            fill='none'
        >
            <path
                d='M5 0L6.32839 3.17162L9.75528 3.45492L7.14939 5.69838L7.93893 9.04508L5 7.26L2.06107 9.04508L2.85061 5.69838L0.244718 3.45492L3.67161 3.17162L5 0Z'
                fill='#090B2A'
            />
        </svg>
    );
};

export default StarIcon;
